import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
function CommentActionButton({
  icon,
  tooltipMessage,
  onClick = () => null,
  isCommentCreator,
  dataTestId
}) {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `comments.${tooltipMessage}`
    }),
    children: /*#__PURE__*/_jsx(IconButton, {
      size: "xs",
      use: "tertiary",
      disabled: !isCommentCreator,
      onClick: onClick,
      "data-test-id": dataTestId,
      children: icon
    })
  });
}
export default CommentActionButton;